import { render } from "./createTraining.vue?vue&type=template&id=eba5a364&scoped=true"
import script from "./createTraining.vue?vue&type=script&lang=js"
export * from "./createTraining.vue?vue&type=script&lang=js"

import "./createTraining.vue?vue&type=style&index=0&id=eba5a364&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba5a364"]])

export default __exports__